module.exports = __webpack_public_path__ + "img/14.73de2511.png";